<div class="user-header">
  <glxy-avatar
    [src]="profilePictureUrl()"
    [name]="displayName()"
    [width]="large() ? 32 : 18"
    [shape]="shape()"
  ></glxy-avatar>
  <div class="user-name">
    @if (linkToContactPage()) {
      <a [routerLink]="profileUrl$ | async">
        {{ displayName() }}
      </a>
    } @else {
      {{ displayName() }}
    }
  </div>
</div>
